<template>
  <div>
    <div class="clearfix mt-3 mb-3">
      <div class="float-left page-title"><mdb-icon icon="chalkboard-teacher" /> {{this.$route.query.name}} 필답 평가 결과</div>
      <div class="float-right"><mdb-btn class="p-2" icon="undo" @click="onBack">돌아가기</mdb-btn></div>
    </div>
    <div v-if="result.test">
      <div class="sub-title">점수: {{this.result.answer.score}} 점</div>
      <div v-for="(t, tx) in tests" :key="tx" class="mb-3">
        <div class="sub-title my-3 underline"><mdb-icon icon="chalkboard" /> {{t.unitName}}</div>
        <div v-for="(q, qx) in t.questions" :key="qx" class="mb-3 ml-4">
          <question-view :question="q" :answer="answers[tx].answers[qx]" :num="qx"/>
        </div>
      </div>
    </div>
    <div class="text-right"><mdb-btn class="p-2" icon="undo" @click="onBack">돌아가기</mdb-btn></div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import FolderLabel from '@/components/common/FolderLabel.vue'
import TestStatus from '@/components/test/TestStatus.vue';
import QuestionView from '@/components/test/QuestionView.vue';
export default {
  components: { QuestionView },
  name: 'StudentWritingTestView',
  props: [],
  data: () => ({
    result: {},
    tests: {},
    answers: {}
  }),
  methods: {
    onBack () {
      this.$router.push({ name: 'StudentTestSummaryPage' })
    }
  },
  async created () {
    const query = this.$route.query
    this.result = await this.$getWritingTestAndAnswer(query)
    this.tests = this.result.test.test
    this.answers = this.result.answer.testAnswers
  }
}
</script>
